// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==================== TAB BAR LAYOUT ====================
   Flex layout with left and right sections
   ====================================================== */

  .st-tab-bar-left,
  .st-tab-bar-right {
    display: flex;
    align-items: center;
    gap: 0;
  }
  
  .st-tab-bar-left { flex: 1 1; }
  
  .st-tab-bar-right {
    margin-left: auto;
    gap: 8px;
    border-left: 1px solid rgba(255, 255, 255, 0.08);
    padding-left: 12px;
  }
  
  /* ── Delete Account Button ─────────────────────────────── */
  .st-tab-btn--delete {
    background: none !important;
    color: white !important;
    /* border-color: rgba(244, 67, 54, 0.20) !important; */
  }
  
  .st-tab-btn--delete:hover {
    background: rgba(244, 67, 54, 0.15) !important;
    border-color: rgba(244, 67, 54, 0.35) !important;
  }
  
  /* ── Logout Button ─────────────────────────────────────── */
  .st-tab-btn--logout {
    background: rgba(76, 175, 80, 0.08) !important;
    color: #81c784 !important;
    border-color: rgba(76, 175, 80, 0.20) !important;
  }
  
  .st-tab-btn--logout:hover {
    background: rgba(76, 175, 80, 0.15) !important;
    border-color: rgba(76, 175, 80, 0.35) !important;
  }
  
  /* ==================== SECURITY SETTINGS STYLES ====================
     Prefix: sec- to avoid collisions
     ================================================================ */
  
  .sec-root {
    display: flex;
    flex-direction: column;
    gap: 0;
  }
  
  .sec-master-toggle {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
    padding: 18px 20px;
    background: rgba(255, 255, 255, 0.03);
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 12px;
    margin-bottom: 24px;
  }
  
  .sec-master-toggle-info {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }
  
  .sec-master-toggle-title {
    font-size: 14px;
    font-weight: 700;
    color: rgba(255, 255, 255, 0.88);
  }
  
  .sec-master-toggle-desc {
    font-size: 12.5px;
    color: rgba(255, 255, 255, 0.40);
    line-height: 1.55;
  }
  
  .sec-content {
    animation: sec-fadeIn 0.2s ease;
  }
  
  @keyframes sec-fadeIn {
    from { opacity: 0; transform: translateY(5px); }
    to   { opacity: 1; transform: translateY(0);   }
  }
  
  .sec-info-banner {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    background: rgba(33, 150, 243, 0.08);
    border: 1px solid rgba(33, 150, 243, 0.20);
    border-radius: 9px;
    padding: 13px 16px;
    margin-top: 20px;
  }
  
  .sec-info-banner span {
    font-size: 1.1rem;
    flex-shrink: 0;
    margin-top: 1px;
  }
  
  .sec-info-banner p {
    font-size: 12.5px;
    color: rgba(255, 255, 255, 0.55);
    margin: 0;
    padding: 0;
    line-height: 1.65;
  }
  
  .sec-link {
    color: #64b5f6;
    text-decoration: none;
    font-weight: 600;
  }
  
  .sec-link:hover {
    text-decoration: underline;
  }
  
  /* ── Responsive ────────────────────────────────────────── */
  @media (max-width: 768px) {
    .st-tab-bar {
      flex-direction: column;
      align-items: stretch;
      gap: 8px;
    }
  
    .st-tab-bar-left,
    .st-tab-bar-right {
      width: 100%;
      border-left: none;
      padding-left: 0;
      gap: 6px;
    }
  
    .st-tab-bar-right {
      border-top: 1px solid rgba(255, 255, 255, 0.08);
      padding-top: 8px;
      margin-left: 0;
    }
  
    .st-tab-btn {
      font-size: 12px;
      padding: 8px 10px;
    }
  
    .sec-master-toggle {
      flex-direction: column;
      align-items: flex-start;
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/components/Pages/common/Settings/Styles/SecuritySettings.css"],"names":[],"mappings":"AAAA;;2DAE2D;;EAEzD;;IAEE,aAAa;IACb,mBAAmB;IACnB,MAAM;EACR;;EAEA,mBAAmB,SAAO,EAAE;;EAE5B;IACE,iBAAiB;IACjB,QAAQ;IACR,gDAAgD;IAChD,kBAAkB;EACpB;;EAEA,6DAA6D;EAC7D;IACE,2BAA2B;IAC3B,uBAAuB;IACvB,sDAAsD;EACxD;;EAEA;IACE,8CAA8C;IAC9C,gDAAgD;EAClD;;EAEA,6DAA6D;EAC7D;IACE,8CAA8C;IAC9C,yBAAyB;IACzB,gDAAgD;EAClD;;EAEA;IACE,8CAA8C;IAC9C,gDAAgD;EAClD;;EAEA;;uEAEqE;;EAErE;IACE,aAAa;IACb,sBAAsB;IACtB,MAAM;EACR;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,kBAAkB;IAClB,qCAAqC;IACrC,2CAA2C;IAC3C,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,gCAAgC;EAClC;;EAEA;IACE,iBAAiB;IACjB,gCAAgC;IAChC,iBAAiB;EACnB;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,OAAO,UAAU,EAAE,0BAA0B,EAAE;IAC/C,OAAO,UAAU,EAAE,wBAAwB,IAAI;EACjD;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,oCAAoC;IACpC,0CAA0C;IAC1C,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,gCAAgC;IAChC,SAAS;IACT,UAAU;IACV,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,qBAAqB;IACrB,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA,6DAA6D;EAC7D;IACE;MACE,sBAAsB;MACtB,oBAAoB;MACpB,QAAQ;IACV;;IAEA;;MAEE,WAAW;MACX,iBAAiB;MACjB,eAAe;MACf,QAAQ;IACV;;IAEA;MACE,+CAA+C;MAC/C,gBAAgB;MAChB,cAAc;IAChB;;IAEA;MACE,eAAe;MACf,iBAAiB;IACnB;;IAEA;MACE,sBAAsB;MACtB,uBAAuB;IACzB;EACF","sourcesContent":["/* ==================== TAB BAR LAYOUT ====================\n   Flex layout with left and right sections\n   ====================================================== */\n\n  .st-tab-bar-left,\n  .st-tab-bar-right {\n    display: flex;\n    align-items: center;\n    gap: 0;\n  }\n  \n  .st-tab-bar-left { flex: 1; }\n  \n  .st-tab-bar-right {\n    margin-left: auto;\n    gap: 8px;\n    border-left: 1px solid rgba(255, 255, 255, 0.08);\n    padding-left: 12px;\n  }\n  \n  /* ── Delete Account Button ─────────────────────────────── */\n  .st-tab-btn--delete {\n    background: none !important;\n    color: white !important;\n    /* border-color: rgba(244, 67, 54, 0.20) !important; */\n  }\n  \n  .st-tab-btn--delete:hover {\n    background: rgba(244, 67, 54, 0.15) !important;\n    border-color: rgba(244, 67, 54, 0.35) !important;\n  }\n  \n  /* ── Logout Button ─────────────────────────────────────── */\n  .st-tab-btn--logout {\n    background: rgba(76, 175, 80, 0.08) !important;\n    color: #81c784 !important;\n    border-color: rgba(76, 175, 80, 0.20) !important;\n  }\n  \n  .st-tab-btn--logout:hover {\n    background: rgba(76, 175, 80, 0.15) !important;\n    border-color: rgba(76, 175, 80, 0.35) !important;\n  }\n  \n  /* ==================== SECURITY SETTINGS STYLES ====================\n     Prefix: sec- to avoid collisions\n     ================================================================ */\n  \n  .sec-root {\n    display: flex;\n    flex-direction: column;\n    gap: 0;\n  }\n  \n  .sec-master-toggle {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 20px;\n    padding: 18px 20px;\n    background: rgba(255, 255, 255, 0.03);\n    border: 1px solid rgba(255, 255, 255, 0.08);\n    border-radius: 12px;\n    margin-bottom: 24px;\n  }\n  \n  .sec-master-toggle-info {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n  }\n  \n  .sec-master-toggle-title {\n    font-size: 14px;\n    font-weight: 700;\n    color: rgba(255, 255, 255, 0.88);\n  }\n  \n  .sec-master-toggle-desc {\n    font-size: 12.5px;\n    color: rgba(255, 255, 255, 0.40);\n    line-height: 1.55;\n  }\n  \n  .sec-content {\n    animation: sec-fadeIn 0.2s ease;\n  }\n  \n  @keyframes sec-fadeIn {\n    from { opacity: 0; transform: translateY(5px); }\n    to   { opacity: 1; transform: translateY(0);   }\n  }\n  \n  .sec-info-banner {\n    display: flex;\n    align-items: flex-start;\n    gap: 10px;\n    background: rgba(33, 150, 243, 0.08);\n    border: 1px solid rgba(33, 150, 243, 0.20);\n    border-radius: 9px;\n    padding: 13px 16px;\n    margin-top: 20px;\n  }\n  \n  .sec-info-banner span {\n    font-size: 1.1rem;\n    flex-shrink: 0;\n    margin-top: 1px;\n  }\n  \n  .sec-info-banner p {\n    font-size: 12.5px;\n    color: rgba(255, 255, 255, 0.55);\n    margin: 0;\n    padding: 0;\n    line-height: 1.65;\n  }\n  \n  .sec-link {\n    color: #64b5f6;\n    text-decoration: none;\n    font-weight: 600;\n  }\n  \n  .sec-link:hover {\n    text-decoration: underline;\n  }\n  \n  /* ── Responsive ────────────────────────────────────────── */\n  @media (max-width: 768px) {\n    .st-tab-bar {\n      flex-direction: column;\n      align-items: stretch;\n      gap: 8px;\n    }\n  \n    .st-tab-bar-left,\n    .st-tab-bar-right {\n      width: 100%;\n      border-left: none;\n      padding-left: 0;\n      gap: 6px;\n    }\n  \n    .st-tab-bar-right {\n      border-top: 1px solid rgba(255, 255, 255, 0.08);\n      padding-top: 8px;\n      margin-left: 0;\n    }\n  \n    .st-tab-btn {\n      font-size: 12px;\n      padding: 8px 10px;\n    }\n  \n    .sec-master-toggle {\n      flex-direction: column;\n      align-items: flex-start;\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
